import { Component, Input } from '@angular/core';
import { NbCardModule, NbButtonModule, NbLayoutModule, NbTabsetModule, NbCalendarModule, NbIconModule,NbSpinnerModule } from '@nebular/theme';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NB_DIALOG_CONFIG, NbDialogRef } from "@nebular/theme";
import { IntranetService } from "../../intranet/service/intranet.service";
import { Store } from '../../../../@core/store/store';
import { ForexRequestLoadedState, ForexRequestLoadingState,ForexRequestLoadingErrorState } from '../../intranet/service/intranet.state';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'ltts-forex-approval-confirm',
  templateUrl: './forex-approval-confirm.component.html',
  standalone: true,
  imports:[
    
    NbButtonModule, NbLayoutModule, NbTabsetModule, FlexLayoutModule,NbCalendarModule, NbIconModule,NbSpinnerModule, NbCardModule,
    
    
  ],
  styleUrls: ['./forex-approval-confirm.component.scss']
})
export class ForexApprovalConfirmComponent {
  loading: boolean = false;
  forexApprovalData: any;
  @Input() parentDialogRef: NbDialogRef<any>

  constructor(protected dialogRef: NbDialogRef<ForexApprovalConfirmComponent>,private intranetService:IntranetService,private toastrService: NbToastrService) {
  }
@Input() set data(value: any) {
    if (value) {
      this.forexApprovalData = value;
    }
  }
  confirm(forexId){
      
     this.intranetService.approveForexRequest(forexId).subscribe({
             next: (state: Store.State) => {
               if (state instanceof ForexRequestLoadingState) {
                 this.loading = true;
               } else if (state instanceof ForexRequestLoadedState) {
                 this.data = state.data.data;
                 this.loading = false;
                 this.dialogRef.close('approved');
                this.parentDialogRef.close('approved'); // close main dialog
        

               }
             },
             error: (error) => {
               this.loading = false;
               this.toastrService.danger("Failed to data. Please try again later.", "Error", { duration: 3000 });
             }
           });
  }

   dismiss() {
    this.dialogRef.close();
  }

}
